module.exports = __webpack_public_path__ + "img/Jack Balas logo.c1028a91.png";